import { ExcelExportParams } from "@ag-grid-community/core";
import i18n from "i18n/config";
import { filenamify } from "shared/utils/Filenamify";

export const DEFAULT_EXPORT_TITLE = i18n.t("common:export");

export const maybernTableExcelExportParams = (
  title: string = DEFAULT_EXPORT_TITLE,
): ExcelExportParams => {
  const fileName = `${filenamify(title)}.xlsx`;
  return {
    fileName,
    sheetName: sanitizeExcelSheetName(title),
  };
};

// https://github.com/apache/poi/blob/a3488f6c392871b033ad12650863d786cef735ad/poi/src/main/java/org/apache/poi/ss/util/WorkbookUtil.java#L48
const sanitizeExcelSheetName = (name: string) =>
  name.replace(/[/\\[\]*?:'"]/g, "").substring(0, 31);
